import { premiumBuildingsPrices } from "@/config/constants";
import { FrameName } from "../config";
import FoundryBuildingTileEntity from "./FoundryBuildingTileEntity";

class IndustrialFoundryBuildingTileEntity extends FoundryBuildingTileEntity {
	public static readonly frameName = FrameName.INDUSTRIAL_FOUNDRY;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];
}

export default IndustrialFoundryBuildingTileEntity;
